exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fav-card[data-v-0646c299]{border-bottom:1px solid #d3d3d3}.fav-card[data-v-0646c299],.fav-card>div[data-v-0646c299]{display:flex;align-items:flex-start}.fav-card>div[data-v-0646c299]{flex-direction:column;padding:10px;font-size:.8rem;width:580px}.fav-card>div>img[data-v-0646c299]{width:470px;height:161px;-o-object-fit:cover;object-fit:cover}@media only screen and (min-width:490px){.fav-card>div[data-v-0646c299]{flex-direction:row}.fav-card>div>img[data-v-0646c299]{height:161px;width:470px}}", ""]);

// exports
